import React from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import { useStyles } from './TechlinkNavbar_style'
import { AppBar, Box, Container, Typography, Hidden } from '@material-ui/core'
import TechlinkNavigationButton from './TechlinkNavigationButton/TechlinkNavigationButton'
import LanguageDropdown from 'inputs/LanguageDropdown/LanguageDropdown'
import RouteMap from 'assets/RouteMap'

const TechlinkNavbar = (props) => {
    const { intl, company, job } = props
    const classes = useStyles()
    const page = window.location.pathname.slice(3)
    const { formatMessage } = intl

    const companyName = company?.name || (job && job.company.name)
    const companyUrl = company?.url || (job && job.company_url)

    const pathname = window.location.pathname.replace(/%C3%A8/g, 'è').replace(/%C3%A9/g, 'é').replace(/\_/g, '-')
    const urlArray = pathname.slice(1).split('/')
    const showSlug = urlArray[3]

    let altLangUrls
    if (company) {
        altLangUrls = {
            current: window.location.href,
            fr: RouteMap.Page(`techlink/entreprises/${showSlug}`, 'fr'),
            en: RouteMap.Page(`techlink/companies/${showSlug}`, 'en'),
            nl: RouteMap.Page(`techlink/bedrijven/${showSlug}`, 'nl')
        }
    } else if (job?.type === 'first_job') {
        altLangUrls = {
            current: window.location.href,
            fr: RouteMap.Page(`techlink/premiers-emplois/${showSlug}`, 'fr'),
            en: RouteMap.Page(`techlink/first-jobs/${showSlug}`, 'en'),
            nl: RouteMap.Page(`techlink/eerste-jobs/${showSlug}`, 'nl')
        }
    } else if (job?.type === 'student_job') {
        altLangUrls = {
            current: window.location.href,
            fr: RouteMap.Page(`techlink/jobs-etudiants/${showSlug}`, 'fr'),
            en: RouteMap.Page(`techlink/student-jobs/${showSlug}`, 'en'),
            nl: RouteMap.Page(`techlink/studentenjobs/${showSlug}`, 'nl')
        }
    } else if (job?.type === 'first_job') {
        altLangUrls = {
            current: window.location.href,
            fr: RouteMap.Page(`techlink/stages/${showSlug}`, 'fr'),
            en: RouteMap.Page(`techlink/internship/${showSlug}`, 'en'),
            nl: RouteMap.Page(`techlink/stages/${showSlug}`, 'nl')
        }
    } else {
        altLangUrls = {
            current: window.location.href,
            fr: RouteMap.Page('techlink/entreprises', 'fr'),
            en: RouteMap.Page('techlink/companies', 'en'),
            nl: RouteMap.Page('techlink/bedrijven', 'nl')
        }
    }


    const getJobShowUrl = () => {
        if (job.type === 'first_job') return `techlink/${formatMessage({ id: 'routes.first-jobs' })}/${job.url}`
        if (job.type === 'student_job') return `techlink/${formatMessage({ id: 'routes.student-jobs' })}/${job.url}`
        if (job.type === 'internship') return `techlink/${formatMessage({ id: 'routes.internships' })}/${job.url}`
    }

    return <>
        <AppBar color='white' elevation={0} className={classes.appBar}>
            <Container className={classes.menuContainer} disableGutters>
                <Box className={classes.leftContainer}>
                    <Box className={classes.linksContainer}>
                        <TechlinkNavigationButton
                            name={<FormattedMessage id='page_footer_navbar_data.companies_burger' />}
                            page={page}
                            url={`techlink/${formatMessage({ id: 'routes.companies' })}`}
                        />
                        {companyName && <>
                            <Typography className={classes.breadcrumbArrow}>
                                {'>'}
                            </Typography>
                            <TechlinkNavigationButton
                                name={companyName}
                                page={page}
                                url={`techlink/${formatMessage({ id: 'routes.companies' })}/${companyUrl}`}
                            />
                        </>}
                        {job && <Hidden smDown>
                            <Typography className={classes.breadcrumbArrow}>
                                {'>'}
                            </Typography>
                            <TechlinkNavigationButton
                                name={job.title}
                                page={page}
                                url={getJobShowUrl()}
                            />
                        </Hidden>}
                    </Box>
                </Box>
                <Box className={classes.rightContainer}>
                    <LanguageDropdown
                        altLangUrls={altLangUrls}
                        allLangsFlat
                    />
                </Box>
            </Container>
        </AppBar>
    </>
}

export default injectIntl(TechlinkNavbar)
